import { ProcessDeUtil } from '../../../domain/process-de-util';

export class PerformerEntity {
    constructor(id?: string, name?: string, type?: string) {
        this.id = '_' + ProcessDeUtil.GenerateElementId();
        this.performerId = id;
        this.performerName = name;
        this.type = type;
    }
    id: string;
    performerId: string;
    performerCode: string;
    performerName: string;
    type: string;
    orgId?: string;
    orgName?: string;
    orgType?: string;
    condition?: string;
    tag?: string;
}
